const clientTypeList: UnknownObj[] = [
  { text: "Comércio" },
  { text: "Indústria" },
  { text: "Residencial / Pessoal Física" },
  { text: "Produtor Rural" },
  { text: "Órgão de administração pública estadual direta" },
  { text: "Prestador de serviço de telecomunicação responsável" },
  {
    text:
      "Missões Diplomáticas, Repartições Consulares e Organizações Internacionais"
  },
  { text: "Igrejas e Templos de qualquer natureza" },
  { text: "Outros não especificados anteriormente" }
];

const subTypeList: UnknownObj[] = [
  { text: "Comércio / Industrial" },
  { text: "Poder Público" },
  { text: "Residencial / Pessoal Física" },
  { text: "Público" },
  { text: "Semi-Público" },
  { text: "Outros" }
];

const industryList: UnknownObj[] = [
  { text: "Execução da mesma natureza" },
  { text: "Indústria" },
  { text: "Comércio" },
  { text: "Serviço de Transporte" },
  { text: "Distribuidora de enérgica elétrica" },
  { text: "Não Contribuinte" },
  { text: "Produtor Rural" }
];

const state: AuthStateObj = {
  profile: {},
  clientTypeList,
  subTypeList,
  industryList
};

export default { ...state };
